import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowLeft, Loader2, Mail, MailCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
    } catch {}
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-4 py-16 text-zinc-100">
      <div className="noise-overlay" aria-hidden="true" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="gradient-ring w-full max-w-md rounded-2xl p-8 shadow-[0_24px_80px_rgba(0,0,0,0.6)]"
      >
        <span className="font-display text-lg font-extrabold tracking-tight">
          LUIZ<span className="text-[#E50914]">.DEV</span>
        </span>

        {sent ? (
          <div className="mt-8 text-center" data-testid="forgot-success">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#E50914]/10">
              <MailCheck className="h-7 w-7 text-[#E50914]" />
            </div>
            <h1 className="mt-6 font-display text-2xl font-bold">Verifique seu e-mail</h1>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">
              Se <span className="text-zinc-200">{email}</span> tiver uma conta, você vai receber um
              link para criar uma nova senha. O link vale por 1 hora.
            </p>
            <a
              data-testid="forgot-back-login"
              href="/entrar"
              className="btn-red-glow mt-8 inline-flex items-center justify-center rounded-full bg-[#E50914] px-8 py-3.5 font-mono-code text-xs font-bold uppercase tracking-widest text-white"
            >
              Voltar ao login
            </a>
          </div>
        ) : (
          <>
            <h1 className="mt-6 font-display text-2xl font-bold">Esqueci minha senha</h1>
            <p className="mt-2 text-sm text-zinc-500">
              Digite seu e-mail e enviamos um link para você criar uma nova senha.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div className="relative">
                <Mail className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-600" />
                <input
                  data-testid="forgot-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Seu e-mail"
                  className="h-12 w-full rounded-xl border border-[#22222A] bg-[#050505] pl-11 pr-4 text-sm text-zinc-100 outline-none transition-colors placeholder:text-zinc-600 focus:border-[#E50914]/60"
                />
              </div>
              <button
                data-testid="forgot-submit-btn"
                type="submit"
                disabled={loading}
                className="btn-red-glow flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[#E50914] font-mono-code text-sm font-bold uppercase tracking-widest text-white disabled:opacity-50"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enviar link"}
              </button>
            </form>
            <a
              data-testid="forgot-back-to-login"
              href="/entrar"
              className="mt-6 flex items-center justify-center gap-2 text-xs text-zinc-500 transition-colors hover:text-[#E50914]"
            >
              <ArrowLeft className="h-3.5 w-3.5" />
              Voltar ao login
            </a>
          </>
        )}
      </motion.div>
    </div>
  );
}
